import { CPQQuoteType } from '@weave/schema-gen-ts/dist/schemas/salesforce/v1/salesforce.pb';
import { http } from '@frontend/fetch';
import { sentry } from '@frontend/tracking';
import { IntakeFormLocation } from './types';

export const logOnboardingSentryError = (errorMessage: string, error?: unknown) => {
  if (error) {
    // ignoring 401 API errors
    if (http.isHttpError(error) && error.status === 401) {
      return;
    }
    console.error(error);
  }

  sentry.error({ team: 'fe-activation', error: errorMessage, topic: 'onboarding' });
};

export type PrepareIntakeFormStoreInfoFromLocationList = (args: {
  intakeFormLocations?: IntakeFormLocation[];
  userEmail?: string;
  isParentLocation?: boolean;
  isWeaveUser?: boolean;
}) => {
  intakeFormLocations?: IntakeFormLocation[];
  ownIntakeFormLocations: IntakeFormLocation[];
  isShowIntakeForm: boolean;
  isSingleSoftwareOnlyLocation: boolean;
  isQuoteTypeEventSingleLocation: boolean;
  isFastPassEligibleLocation: boolean;
  isShippingAddressVerified: boolean;
};

export const prepareIntakeFormStoreInfoFromLocationList: PrepareIntakeFormStoreInfoFromLocationList = ({
  intakeFormLocations = [],
  userEmail = '',
  isParentLocation = false,
  isWeaveUser = false,
}) => {
  const ownIntakeFormLocations: IntakeFormLocation[] = [];
  let hasOwnIncompleteIntakeForms = false;
  let hasIncompleteIntakeForms = false;

  intakeFormLocations
    .filter(({ error }) => !error)
    .forEach((location) => {
      if (!location.onboardingContactEmail || location.onboardingContactEmail === userEmail || isWeaveUser) {
        ownIntakeFormLocations.push(location);
        hasOwnIncompleteIntakeForms = hasOwnIncompleteIntakeForms || !location.formCompletedAt;
      }
      hasIncompleteIntakeForms = hasIncompleteIntakeForms || !location.formCompletedAt;
    });

  const isShowIntakeForm = isParentLocation ? hasOwnIncompleteIntakeForms : hasIncompleteIntakeForms;
  const isSingleLocation = intakeFormLocations.length === 1 && !intakeFormLocations[0].isMultiForm;
  const firstLocation: IntakeFormLocation = intakeFormLocations[0] || {};

  const isSingleSoftwareOnlyLocation = isSingleLocation && !!firstLocation.isSoftwareOnlyForm;
  const isQuoteTypeEventSingleLocation = isSingleLocation && firstLocation.quoteType === CPQQuoteType.EVENT;
  const isFastPassEligibleLocation = isSingleLocation && !!firstLocation.isFastPassEligibleLocation;
  const isShippingAddressVerified = isSingleLocation && !!firstLocation.isShippingAddressVerified;

  return {
    intakeFormLocations,
    ownIntakeFormLocations,
    isShowIntakeForm,
    isSingleSoftwareOnlyLocation,
    isQuoteTypeEventSingleLocation,
    isFastPassEligibleLocation,
    isShippingAddressVerified,
  };
};
